import { ApiProperty } from "@nestjs/swagger";

export class GradePatternRequest{
    @ApiProperty()
    count: number;
    @ApiProperty()
    maxCount: number;
    @ApiProperty()
    plantId?: number;
   
}